var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "loading-energy-saving",
    width: 80.338,
    height: 69.857,
    viewBox: "0 0 80.338 69.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(0 31.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M73.046,189.756l-.01,0h0a1.477,1.477,0,0,0-1.782,1.081A31.969,31.969,0,0,1,10.4,195.058l5.288-1.114a1.476,1.476,0,0,0,.825-2.434l-4.744-5.3-4.7-5.2a1.477,1.477,0,0,0-2.574.454l-2.211,6.757L.074,194.96a1.477,1.477,0,0,0,1.708,1.906l5.692-1.2a34.922,34.922,0,0,0,66.651-4.125A1.477,1.477,0,0,0,73.046,189.756Z",
    transform: "translate(0 -180.445)",
    strokeWidth: 10,
    fill: "#048041"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(6.183 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M103.117,46.936a1.476,1.476,0,0,0-.766-.042V46.87l-5.692,1.2a34.922,34.922,0,0,0-66.651,4.125,1.477,1.477,0,0,0,2.871.685A31.969,31.969,0,0,1,93.73,48.652l-5.288,1.114a1.476,1.476,0,0,0-.825,2.434l4.744,5.3,4.678,5.222a1.477,1.477,0,0,0,2.574-.454l2.211-6.757,2.236-6.707A1.477,1.477,0,0,0,103.117,46.936Z",
    transform: "translate(-29.978 -25.409)",
    strokeWidth: 10,
    fill: "#048041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/SyncIcon.cbe43f3986d0507b21af963336f4ca35.svg";
export { ForwardRef as ReactComponent };